<template>
  <div class="cursor-pointer w-full" @click="navigateToBalanceReport()" data-vs-button="toDocumentSearch">
    <div class="p-4 flex">
      <div class="mx-auto">
        <pictogramCalendar />
      </div>
      <div class="flex justify-end text-zt-primary-200 p-4 text-xl">
        <p class="pl-2 self-center">{{ $t('message.LicensesManager.balances.title') }}</p>
        <zt-icon name="angle-right" />
      </div>
    </div>
  </div>
</template>

<script>
import pictogramCalendar from '@/components/commons/Illustrations/graphicSVG/PictogramCalendarSVG'
export default {
  name: "TeamBalanceReport",
  components: {
    pictogramCalendar
  },
  methods: {
    navigateToBalanceReport() {
      this.$router.push({ name: 'licensesBalances', params: { routerGo: 'dashboard' } });
    },
  },
}
</script>

<style lang="scss" scoped></style>